import React from 'react'
import { I18n } from 'react-redux-i18n';
import Alert from '../../../baseApp/shared/components/alerts/Alert';
import FormButtons from "../../../baseApp/shared/components/others/formButtons/FormButtons";
import InfoBoxes from "../../../baseApp/shared/components/others/InfoBoxes";
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import StringUtils from "../../../baseApp/shared/utils/StringUtils";
import MeetingRoomsScheduleEventsContainer from '../containers/MeetingRoomsScheduleEventsContainer';
import { appModules } from '../../../baseApp/roles/components/UserHasPermission';
import SwitchField from '../../../baseApp/shared/components/fields/switchField/SwitchField';

const MeetingRoomViewForm = ({
    name,
    status,
    meetingRoomId,
    entityLastReadings: {
        TEMPERATURE,
        PEOPLE_COUNTER
    } = {},
    operationTimeStart,
    operationTimeEnd,
    email,
    capacity,
    eventsForCalendar,
    alert,
    editMode,
    viewMode,
    handleBackClick,
    handleEditClick,
    handleDeleteClick,
    hasQuickBook
}) => {

    /* const minTime = operationTimeStart ? parseInt(operationTimeStart.split(":")[0]) : 8;
    const maxTime = operationTimeStart ? parseInt(operationTimeEnd.split(":")[0]) : 20; */
 /*    const quickbook = <SwitchField
        checked={hasQuickBook}
        width={2}
    /> */
    const quickbook = hasQuickBook === true ? "Active": "Inactive"
    const minTime = operationTimeStart ? parseInt(operationTimeStart.split(":")[0]) : "";
    const maxTime = operationTimeStart ? parseInt(operationTimeEnd.split(":")[0]) : "";
    const hyphen = maxTime > 0 ? " - " : ""
    const h = maxTime > 0 ? "h" : ""
    const boxes = [{
        data: status ? StringUtils.stringNormalize(status.value) : "Undefined",
        header: I18n.t("meetingRooms.form.status.label")
    },
    {
        data: email,
        header: I18n.t("meetingRooms.form.subForm.email")
    },
    {
        data: minTime + hyphen + maxTime + h,
        header: I18n.t("meetingRooms.form.subForm.checkInTime")
    },
    {
        data: capacity,
        header: I18n.t("meetingRooms.form.subForm.maxCapacity")
    },
    {
        data: quickbook,
        header: "Allow Quick Book"
    }
        /*{
            data: TEMPERATURE ? TEMPERATURE + "º C" : "No Interface",
            header: I18n.t("meetingRooms.form.temperature.label")
        }, {
            data: PEOPLE_COUNTER ? Math.round(PEOPLE_COUNTER) : "No Interface",
            header: I18n.t("meetingRooms.form.people.label"),
        }
        */
    ];

    const localizer = momentLocalizer(moment);


    const formats = {
        timeGutterFormat: (date, a, localizer) => localizer.format(date, 'HH:mm'),
        eventTimeRangeFormat: ({ start, end }, a, localizer) => localizer.format(start, 'HH:mm') + ' - ' + localizer.format(end, 'HH:mm'),
    };

    return (
        <div>
            <Alert
                {...alert}
            />
            <div className="info-boxes-container">
                <InfoBoxes
                    data={boxes}
                />
                <div className="form-options-row">
                    <FormButtons
                        editMode={editMode}
                        viewMode={viewMode}
                        handleBackClick={handleBackClick}
                        handleEditClick={handleEditClick}
                        handleDeleteClick={handleDeleteClick}
                        appModule={appModules.ENTITY}
                    />
                </div>
            </div>
            <div className="big-calendar-container">
                <BigCalendar
                    localizer={localizer}
                    events={eventsForCalendar}
                    startAccessor="start"
                    endAccessor="end"
                    defaultView="work_week"
                    views={['day', 'work_week']}
                    step={15}
                    formats={formats}
                    selectable={false}
                    min={new Date(0, 0, 0, minTime, 0, 0)}
                    max={new Date(0, 0, 0, maxTime, 0, 0)}
                />
            </div>
            <div className="meeting-room-view__events-table">
                <MeetingRoomsScheduleEventsContainer
                    meetingRoomId={meetingRoomId}
                />
            </div>
        </div>
    );
};

export default MeetingRoomViewForm;